import {
  formatPlainDate,
  type PlainDateString,
} from "@sa-nu/shared-utils/date";
import { formatCurrency } from "@sa-nu/shared-utils/price";

/**
 * 「予約する」CTA に表示する日付・価格ラベルを生成する。
 *
 * - `guaranteedPrice` が `null` または `<= 0` の場合は「未確定」表現 (`yyyy/mm/dd ~`) のみ
 * - 正の `guaranteedPrice` がある場合は「1 泊 + 価格」(`yyyy/mm/dd から1泊` + `¥30,000`)
 *
 * 戻り値の `priceLabel` は価格が無いときは省略する (= `undefined`)。
 */
export function buildReserveCtaLabels(args: {
  date: PlainDateString;
  guaranteedPrice: number | null | undefined;
}): { dateLabel: string; priceLabel?: string } {
  const dateStr = formatPlainDate(args.date, { format: "slash", pad: true });
  const price = args.guaranteedPrice;
  if (price != null && price > 0) {
    return {
      dateLabel: `${dateStr}から1泊`,
      priceLabel: formatCurrency(price),
    };
  }
  return { dateLabel: `${dateStr} ~` };
}
